import { useQuery } from '@tanstack/react-query';
import api from 'services/api/api';

export const getBrand = async () => {
	const response = await api.get('/marca');
	return response.data;
};
export const useBrandList = () => {
	return useQuery(['brand-list'], getBrand, {
		refetchOnWindowFocus: false,
	});
};
